import {BMTheme} from "../../../BMTheme";

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  tabStyle: {
    paddingLeft: "1em",
    paddingRight: "1em"
  },
  headerSectionStyle: {
    marginTop: 20,
    padding: "1em",
    borderBottom: "1px solid #e0e0e0",
    fontWeight: "bold"
  },
  inputStyle: {
    paddingRight: "4em",
    booleanInput: {
      width: "20em",
      marginTop: "1.5em"
    },
    lastInput: {
      paddingRight: "4em",
      marginBottom: "3em"
    },
    dateInput: {
      float: "left",
      marginRight: "5%",
      marginTop: "2%",
      paddingLeft: "1em"
    },
    richText: {
      float: "left",
      width: "75%",
      paddingLeft: "1em",
      marginBottom: "3em"
    }
  },
  pickerStyle: {
    paddingLeft: "1em"
  },
  labelStyle: {
    float: "left",
    marginRight: "2%",
    paddingLeft: "1em"
  },

  containerInput: {
    float: "left",
    marginRight: "2%"
  },

  titleStyle: {
    textTransform: "capitalize"
  },
  validationImageStyle: {
    display: "flex",
    flex: 1,
    color: BMTheme.formValidation.color,
    fontSize: "80%",
    position: "relative",
    top: 65,
    left: "-253px",
    margin: 0,
    padding: 0
  },
  validationSmallImageStyle: {
    display: "flex",
    flex: 1,
    color: BMTheme.formValidation.color,
    fontSize: "80%",
    position: "relative",
    bottom: 85,
    left: "255px",
    margin: 0,
    padding: 0,
    textAlign: "left"
  },
  dateStyle: {
    float: "left",
    marginRight: "5%",
    marginTop: "2%"
  },
  clearFloatContainer: {
    clear: "both"
  },
  toggle: {
    maxWidth: 250
  },
  richText: {
    float: "left",
    width: "75%",
    paddingLeft: "1em"
  },
  activateButton: {
    float: "left",
    marginTop: "2.5%",
    marginLeft: "5%",
    marginRight: "1em",
    marginBottom: "3em"
  },
  booleanInput: {
    display: "none"
  },
  raisedButtonProgress: {
    marginTop: "0.2em"
  },
  raisedButtonLabel: {
    color: BMTheme.palette.alternateTextColor
  },
  raisedButton: {
    marginTop: "2%",
    width: "10em"
  },
  voucherStyle: {
    paddingLeft: "1em",
    paddingRight: "1em",
    voucherInput : {
      float: "left"
    },
    generateButton: {
      float: "left",
      marginTop: 20,
      marginLeft: 10,
      backgroundColor: BMTheme.palette.primary1Color,
      color: BMTheme.palette.alternateTextColor
    }
  },
  headerStyle: {
    marginTop: 20,
    paddingLeft: "1em",
    paddingRight: "1em"
  }
};

export const viewStyle = {
  textFieldContainer: {
    marginTop: 10
  },
  textFieldStyle: {
    textTransform: "capitalize"
  },
  labelFieldStyle: {
    textTransform: "sentencecase",
    lineHeight: " 22px",
    fontSize: "12px",
    color: BMTheme.label.labelDefaultColor
  },
  booleanContainerStyle: {
    textTransform: "capitalize",
    float: "left",
    width: "20%"
  },
  booleanFieldStyle: {
    margin: 0
  },
  containerStyle: {
    float: "left",
    marginRight: "10%",
    textTransform: "capitalize"
  },
  imageContainerStyle: {
    float: "left",
    marginRight: "10%"
  },

  clearFloatContainer: {
    clear: "both"
  },
  headerStyle: {
    marginTop: 20,
    paddingLeft: "1em",
    paddingRight: "1em"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/style.js